import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import ArrowButton from '../../common/button-arrow';
import IgniteDataTable from '../../common/datatable';
import { getOutletRewardAllocations, saveOutletRewardAllocations } from '../../../actions/outlet-reward-allocations';

import './reward-allocations.css'

const columns = [
  { prop: 'user-id', title: 'User ID', width: '100' },
  { prop: 'name', title: 'Name' },
  { prop: 'email', title: 'Email' },
  { prop: 'mobile', title: 'Mobile' },
  { prop: 'usergroup', title: 'Usergroup' },
  { prop: 'reward-percentage', title: 'Reward allocation % (click to edit staff allocations)', editable: true, width: '400px' }  
];

function add(accumulator, a) {
  return accumulator + a;
}

class RewardAllocations extends Component {
  state = {
    showError: false,
  };

  render() {
    const { dispatch, incentiveId, customerNumber, outletRewardAllocations, incentivesOutletsId } = this.props;
    const {showError} = this.state;

    function onAfterSaveCell(row, cellName, cellValue) {
      outletRewardAllocations.filter(allocation => allocation['user-id'] === row['user-id'])[0]['reward-percentage'] = parseInt(cellValue) ? cellValue : 0;

      outletRewardAllocations[0]['reward-percentage'] = 100 - outletRewardAllocations
                                                              .filter(allocation => allocation['staff-reward-allocation-id'] !== 0 &&
                                                               parseInt(allocation['reward-percentage']))
                                                              .map(allocation => parseInt(allocation['reward-percentage']))
                                                              .reduce(add, 0);
      if (outletRewardAllocations[0]['reward-percentage'] < 0) {
        this.setState({showError: true});
        outletRewardAllocations[0]['reward-percentage'] = 0;
      } else {
        this.setState({showError: false});
      }
    }
    
    const cellEdit = {
      mode: 'click',
      blurToSave: true,
      nonEditableRows: function() { return [0]; },
      afterSaveCell: onAfterSaveCell.bind(this)
    };
    
    function onSaveRewardAllocations() {
      dispatch(saveOutletRewardAllocations(incentiveId, customerNumber, outletRewardAllocations))
        .then(() => {
          dispatch(getOutletRewardAllocations(incentivesOutletsId));
        });
    }

    return (
      <div>
        <Col>
          <IgniteDataTable
            hasAttributes={false}
            data={outletRewardAllocations || []}
            columns={columns}
            cellEdit={cellEdit}
          />
          <Row className="mg-top-20">
            <Col md={10} className="text-right error-container">
              {showError && <span className="allocations-error-message">The sum of staff allocations must be under 100!</span>}
            </Col>
            <Col md={2} className="text-right">
              <ArrowButton arrow={false} disabled={showError} onClick={onSaveRewardAllocations}>Save</ArrowButton>
            </Col>
          </Row>
        </Col>
      </div>
    );
  }
}

export default RewardAllocations;



// WEBPACK FOOTER //
// ./src/components/admin/outlet-reward-allocation-view/reward-allocations.jsx